import React, { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './products-item.css';
import { Skeleton } from 'primereact/skeleton';
import ProductImage from '../../assets/images/defult-img copy.svg';
import Hearth from '../../assets/icons/hearth.svg';
import HeartBold from '../../assets/icons/heart-bold.svg';
import { GetProducts, GetLastProducts, GetBestProducts, addBasket, getBasketList, deleteBasket, getDiscountProduct, getFavoriteList, deleteFavorite, getAddToFavorite, addAddress } from '../../utils/api';
import Trash from '../../assets/icons/trash.svg';
import { Dialog } from 'primereact/dialog';
import { OverlayPanel } from 'primereact/overlaypanel';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import { useNavigate } from 'react-router-dom';

import Loader from '../loader/dotloader';
import ThreeLoader from '../loader/threeDots'
import { useCart } from '../../contexts/CartContext';
import useToastNotification from '../../hooks/useToastNotification';



export default function ProductsSlider({ productCat, productsData }) {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [discountList, setDiscountList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addToBasket, setaddToBasket] = useState(true);
  const [basketList, setBasketList] = useState({});
  const [favoritList, setFavoritList] = useState({});
  const [visible, setVisible] = useState(false); // Dialog visibility state
  const [dialogContent, setDialogContent] = useState({}); // Dialog content state
  const [autoplay, setAutoplay] = useState(true); // کنترل وضعیت autoplay
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const { addToCart } = useCart();
  const [typingState, setTypingState] = useState({});
  const [loadingQuantities, setLoadingQuantities] = useState(false);
  const { showError, showSuccess } = useToastNotification();
  const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
  const [inputValues, setInputValues] = useState({});
  const overlayRef = useRef(null);
  const [show, setShow] = useState(false);
  // داخل کامپوننت:
  const refs = useRef({}); // یک آبجکت برای ذخیره refs به صورت داینامیک

  const ref = useRef(null); // برای container اصلی Overlay

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false); // تابعی که overlay رو می‌بنده
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);

  const getRef = (id) => {
    if (!refs.current[id]) {
      refs.current[id] = React.createRef();
    }
    return refs.current[id];
  };
  const fetchProductData = async () => {
    const basketData = await fetchBasketList();
    const favoriteData = await fetchFavorite()
    if (productCat === 0) {
      await fetchProducts(basketData, favoriteData);
    } else if (productCat === 1) {
      await fetchBestProducts(basketData, favoriteData);
    } else {
      await fetchLastProducts(basketData, favoriteData);
    }
  };
  useEffect(() => {

    fetchProductData();
  }, [productCat]);


  const fetchBasketList = async () => {
    try {
      // setLoading(true)
      const res = await getBasketList(JSON.parse(localStorage.getItem('userInfo')).si);
      const basketData = res.data.reduce((acc, item) => {
        acc[item.Id_Kala] = {
          count: item.Nq,      // تعداد محصول در سبد خرید
          basketId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
        };
        return acc;
      }, {});
      setBasketList(basketData);
      return basketData;
    } catch (error) {
      console.error('Error fetching basket:', error);
      return {};
    } finally {
      setLoading(false)
    }
  };
  const fetchFavorite = async () => {
    try {
      setLoading(true)
      const res = await getFavoriteList(JSON.parse(localStorage.getItem('userInfo')).si);
      const favoriteData = res.data.reduce((acc, item) => {
        acc[item.Id_Kala] = {
          isFavorit: true,      // تعداد محصول در سبد خرید
          favoriteId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
        };
        return acc;
      }, {});
      setFavoritList(favoriteData);
      return favoriteData;
    } catch (error) {
      console.error('Error fetching basket:', error);
      return {};
    } finally {
      setLoading(false)
    }
  };
  const fetchProducts = async (basketData, favoriteData) => {

    const updatedProducts = productsData.map(product => ({
      ...product,
      count: basketData[product.Si]?.count || 0,
      BasketId: basketData[product.Si]?.basketId || '',
      favoriteId: favoriteData[product.Si]?.favoriteId || '',
      isFavorit: favoriteData[product.Si]?.isFavorit || false,
    }));
    setProducts(updatedProducts);

  };

  const fetchBestProducts = async (basketData) => {

    const updatedProducts = productsData.map(product => ({
      ...product,
      count: basketData[product.Si] || 0
    }));
    setProducts(updatedProducts);

  };

  const fetchLastProducts = async (basketData) => {

    const updatedProducts = productsData.map(product => ({
      ...product,
      count: basketData[product.Si] || 0
    }));
    setProducts(updatedProducts);

  };
  const fetchDiscountProduct = async (id) => {
    try {
      setShow(false); // مخفی کردن اولیه
      setSelectedDiscount(null); // پاک کردن مقدار قبلی برای جلوگیری از کش شدن

      const res = await getDiscountProduct(id);
      if (res.data.length > 0) {
        setTimeout(() => {
          setSelectedDiscount({ id, discounts: res.data });
          setShow(true); // نمایش تخفیف جدید
        }, 100); // تاخیر کوتاه برای اطمینان از به‌روز شدن مقدار
      } else {
        setSelectedDiscount(null);
        setShow(false);
      }
    } catch (error) {
      console.error('Error fetching discount:', error);
    }
  };


  useEffect(() => {
  }, [selectedDiscount])

  const changeFavorit = async (product) => {
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    if (!product.isFavorit) {
      let pay = {
        userId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await getAddToFavorite(pay)
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: true } : p
      ));
    } else {
      let pay = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await deleteFavorite(pay)
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: false } : p
      ));
    }
  }


  const handleAddToBasket = async (product, event) => {
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    setSelectedDiscount(null)
    await fetchDiscountProduct(product.Si);
    const newCount = product.MinOrder;
    setProducts(products.map(p =>
      p.Si === product.Si ? { ...p, count: newCount } : p
    ));
    setDialogContent(prev => ({ ...prev, count: newCount }));
    try {
      let res = await addBasket({
        id: product.Si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });
      if (res.status == 200) {
        showSuccess(`${product.KalaName} به سبد خرید اضافه شد.`)

        addToCart();

        let basketData = await fetchBasketList()
        setProducts(products.map(p =>
          p.Si === product.Si ? { ...p, BasketId: basketData[product.Si]?.basketId, count: newCount } : p
        ));
        setDialogContent(prev => ({ ...prev, BasketId: basketData[product.Si]?.basketId }));

        setBasketList(prev => ({
          ...prev,
          [product.Si]: newCount
        }));
      }


    } catch (error) {
      console.error('Error adding to basket:', error);
    }
  };

  const handleIncrease = async (product, event) => {
    const newCount = product.count + 1;
    setInputValues((prevValues) => ({
      ...prevValues,
      [product.Si]: newCount,
    }));

    try {
      await addBasket({
        id: product.Si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });

      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, count: newCount } : p
      ));
    } catch (error) {
      console.error('Error increasing product count:', error);
    }
  };

  const handleDecrease = async (product, event) => {
    const newCount = product.count - 1;


    try {
      if (newCount >= product.MinOrder) {
        await addBasket({
          id: product.Si,
          count: newCount,
          userId: JSON.parse(localStorage.getItem('userInfo')).si
        });
        setInputValues((prevValues) => ({
          ...prevValues,
          [product.Si]: newCount,
        }));

        setProducts(products.map(p =>
          p.Si === product.Si ? { ...p, count: newCount } : p
        ));
      } else {
        await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: product.BasketId
        });
        setProducts(products.map(p =>
          p.Si === product.Si ? { ...p, count: 0 } : p
        ));
        addToCart();

      }


    } catch (error) {
      console.error('Error decreasing product count:', error);
    }
  };

  const openDialog = async (product) => {

    setSelectedDiscount(null)
    const updatedProduct = products.find(p => p.Si === product.Si);
    setDialogContent(updatedProduct || product);
    setVisible(true);

    await fetchDiscountProduct(product.Si)
    setAutoplay(false);
  };
  useEffect(() => {
    if (selectedDiscount && dialogContent.count) {
      checkDiscount(dialogContent.count);
    }
  }, [selectedDiscount, dialogContent.count]);
  useEffect(() => {

  }, [selectedDiscount])
  const handleDialogIncrease = async () => {
    const newCount = dialogContent.count + 1;


    try {
      setLoadingQuantities(true)
      let res = await addBasket({
        id: dialogContent.Si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });
      if (res.status == 200) {
        setInputValues((prevValues) => ({
          ...prevValues,
          [dialogContent.Si]: newCount,
        }));
        setDialogContent(prev => ({ ...prev, count: newCount }));
        setProducts(products.map(p => p.Si === dialogContent.Si ? { ...p, count: newCount } : p));
        setTimeout(() => {
          setLoadingQuantities(false)
          showSuccess(`${parseInt(newCount)} عدد ${dialogContent.KalaName} در سبد خرید شما وجود دارد.`)
        }, 1000);
      }

      // setDialogContent(prev => ({ ...prev, count: newCount }));

      // setProducts(products.map(p =>
      //   p.Si === dialogContent.Si ? { ...p, count: newCount } : p
      // ));
    } catch (error) {
      console.error('Error increasing product count in dialog:', error);
    }
  };

  const handleDialogDecrease = async () => {
    const newCount = dialogContent.count - 1;

    // همگام‌سازی مقدار در دیالوگ و لیست محصولات
    setDialogContent(prev => ({ ...prev, count: newCount }));

    try {
      setLoadingQuantities(true)
      if (newCount >= dialogContent.MinOrder) {
        let res = await addBasket({
          id: dialogContent.Si,
          count: newCount,
          userId: JSON.parse(localStorage.getItem('userInfo')).si
        });
        if (res.status == 200) {
          showSuccess(`${parseInt(newCount)} عدد ${dialogContent.KalaName} در سبد خرید شما وجود دارد.`)
          setInputValues((prevValues) => ({
            ...prevValues,
            [dialogContent.Si]: newCount,
          }));

          setDialogContent(prev => ({ ...prev, count: newCount }));

          setProducts(products.map(p =>
            p.Si === dialogContent.Si ? { ...p, count: newCount } : p
          ));
          setTimeout(() => {
            setLoadingQuantities(false)
          }, 1000);
        }
      } else {
        let res = await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: dialogContent.BasketId
        });
        if (res.status == 200) {
          addToCart();
          showSuccess(`کالا از سبد خرید حذف شد.`)
          setDialogContent(prev => ({ ...prev, count: newCount }));

          setProducts(products.map(p =>
            p.Si === dialogContent.Si ? { ...p, count: 0 } : p
          ));
          setTimeout(() => {
            setLoadingQuantities(false)
          }, 1000);
        }

      }
    } catch (error) {
      console.error('Error decreasing product count in dialog:', error);
    }
  };



  const handleDialogClose = () => {
    setVisible(false);
    setDialogContent({});
  };


  const handleDialogInputChange = (value) => {
    const newCount = parseInt(value) || 0;
    if (newCount >= dialogContent.MinOrder) {
      setDialogContent(prev => ({ ...prev, count: newCount }));
    }
  };

  function convertToPersianNumbers(input) {
    if (input) {

      const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }
  }
  const [isSliding, setIsSliding] = useState(false);

  const settings = {
    arrows: false, // نمایش یا عدم نمایش پیکان‌ها
    autoplaySpeed: 3000,
    beforeChange: () => setIsSliding(true),
    afterChange: () => setIsSliding(false),
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          rtl: productsData?.length > 5,
          autoplay: productsData?.length > 5, // فعال‌سازی خودکار
          draggable: productsData.length > 5,
          infinite: productsData.length > 5, // حلقه‌ای شدن اسلایدر
        },
      },
      {
        breakpoint: 1400,
        settings: {
          rtl: productsData?.length > 5,
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          autoplay: productsData?.length > 5, // فعال‌سازی خودکار
          draggable: productsData.length > 5,
          infinite: productsData.length > 5, // حلقه‌ای شدن اسلایدر
        },
      },
      {
        breakpoint: 1100,
        settings: {
          rtl: productsData?.length > 3,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          autoplay: productsData?.length > 3, // فعال‌سازی خودکار
          draggable: productsData.length > 3,
          infinite: productsData.length > 3, // حلقه‌ای شدن اسلایدر
        },
      },
      {
        breakpoint: 980,
        settings: {
          rtl: productsData?.length > 3,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          autoplay: productsData.length > 3, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
          draggable: productsData.length > 3,
          infinite: productsData.length > 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          rtl: productsData?.length > 2,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          autoplay: productsData.length > 2, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
          draggable: productsData.length > 2,
          infinite: productsData.length > 2,
        },
      },
      {
        breakpoint: 750,
        settings: {
          rtl: productsData?.length > 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: productsData.length > 1, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
          draggable: productsData.length > 1,
          infinite: productsData.length > 1,
        },
      },
    ],
  };




  const handleMouseDownslid = () => setIsScrolling(false);
  const handleMouseMoveslid = () => setIsScrolling(true);
  const handleMouseUpslid = (product) => {
    if (!isScrolling) {
      openDialog(product);
    }
  }
  const changeFavoritDialog = async (product) => {
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    if (!product.isFavorit) {
      let pay = {
        userId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await getAddToFavorite(pay)
      setDialogContent(prevContent => ({
        ...prevContent,
        isFavorit: true

      }));
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: true } : p
      ));
    } else {
      let pay = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await deleteFavorite(pay)
      setDialogContent(prevContent => ({
        ...prevContent,
        isFavorit: false

      }));
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: false } : p
      ));
    }
  }


  // Disable/Enable scroll when dialog is opened/closed
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible]);
  const getTotalPrice = (price, product) => {
    let totalPrice = parseInt(product.count) * parseInt(price)
    return totalPrice.toLocaleString()
  }
  useEffect(() => {

  }, [products])


  const checkDiscount = (count) => {
    console.log(dialogContent)
    if (selectedDiscount?.discounts.length > 0) {


      for (const item of selectedDiscount?.discounts) {
        console.log(selectedDiscount, item.Price, count)
        const nq = item.Nq;
        if (nq) {
          if (nq.includes("از") && nq.includes("تا")) {
            // بازه بین دو عدد
            const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
            if (match) {
              const from = parseInt(match[1]);
              const to = parseInt(match[2]);

              console.log(from, to)
              if (count >= from && count <= to) {
                console.log(selectedDiscount, item.Price, count)
                // setDialogContent(prev => ({ ...prev, Price: item.Price }));
                setDialogContent(prev => ({ ...prev, discountPrice: item.Price }));
                break;
              }
            }
          } else if (nq.includes("بیشتراز")) {
            const match = nq.match(/بیشتراز\s*(\d+)/);
            if (match) {
              const from = parseInt(match[1]);
              if (count > from) {
                setDialogContent(prev => ({ ...prev, discountPrice: item.Price }));
                break;
              }
            }
          }
        }

      }


    }
  }
  useEffect(() => {
    console.log('........', dialogContent)
  }, [dialogContent])
  const handleUpdateBasket = async (newCount, product) => {
    if (!JSON.parse(localStorage.getItem('userInfo')).si) {
      window.location.hash = 'login'; // هدایت به صفحه لاگین
      return;
    }
    try {
      setLoadingQuantities(true)
      if (newCount >= product.MinOrder) {
        let res = await addBasket({ id: product.Si, count: newCount, userId: JSON.parse(localStorage.getItem('userInfo')).si });
        if (res.status == 200) {
          if (product.count > newCount) {
            showSuccess(`${parseInt(newCount)} عدد ${product.KalaName} در سبد خرید شما وجود دارد.`)
          } else {
            showSuccess(`${parseInt(newCount)} عدد ${product.KalaName} در سبد خرید شما وجود دارد.`)
          }
          setTimeout(() => {
            setLoadingQuantities(false)
            checkDiscount(newCount)
          }, 2000);
          setProducts(products.map(p =>
            p.Si === product.Si ? { ...p, count: newCount } : p
          ));

          setDialogContent(prev => ({ ...prev, count: newCount }));
        }

      } else {
        let res = await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: product.BasketId
        });
        if (res.status == 200) {
          setLoadingQuantities(false)
          setProducts(products.map(p =>
            p.Si === product.Si ? { ...p, count: 0 } : p
          ));
          setDialogContent(prev => ({ ...prev, count: 0 }));
        }

      }
    } catch (error) {
      console.error('Error updating basket:', error);
    }
  };



  const typingTimers = useRef({});
  const findProductBySi = (si) => {
    return products.find((p) => p.Si.toString() === si.toString());
  };

  const handleInputChange = (product, value) => {
    const si = product.Si.toString();
    const numericValue = value.replace(/\D/g, '');

    setInputValues(prev => ({
      ...prev,
      [si]: numericValue,
    }));

    // اگر تایمر قبلی وجود داره، حذف کن
    if (typingTimers.current[si]) {
      clearTimeout(typingTimers.current[si]);
    }

    // شروع تایمر جدید
    typingTimers.current[si] = setTimeout(() => {
      const productObj = findProductBySi(si);
      const parsed = parseInt(numericValue, 10);
      const finalCount = isNaN(parsed) || parsed < productObj.MinOrder ? productObj.MinOrder : parsed;

      setInputValues(prev => ({
        ...prev,
        [si]: finalCount.toString(),
      }));

      handleUpdateBasket(finalCount, productObj);

      // حذف تایمر پس از پایان
      delete typingTimers.current[si];
    }, 1200); // 1.2 ثانیه تأخیر
  };


  return (
    <>
      {loading && products.length > 0 ? (
        <div className=''>

          <div className="skeleton-wrapper py-4  web-selekton gap-2 px-0">
            {[...Array(5)].map((_, index) => (
              <div className='product-item flex-1' >
                <div className='product-img aspect-[4/4]'>
                  <Skeleton className='img-box img-product h-100' alt="Image 1" />
                </div>
                <div >
                  <div className='detail w-100'>
                    <Skeleton className='product-title' />
                    <Skeleton className='mt-2 number-font' />
                  </div>

                  <div >
                    <Skeleton height='40px' className='mt-3 btn btn-primary w-100 h-[48px]' />
                    {/* )} */}
                  </div>

                  <Skeleton className='f-10 mt-2' />
                </div>
              </div>
            ))}
          </div>
          <div className="skeleton-wrapper container d-flex gap-2 align-items-center justify-content-between mobile-selekton px-0">
            {[...Array(1)].map((_, index) => (

              <div className='product-item flex-1' >
                <div className='product-img aspect-[4/4]'>
                  <Skeleton className='img-box img-product h-100' alt="Image 1" />
                </div>
                <div className='flex-1 mt-2'>
                  <div className='detail w-100 '>
                    <Skeleton className='product-title' />
                    <Skeleton className='mt-2 number-font' />
                  </div>

                  <div >
                    <Skeleton height='40px' className='mt-3 btn btn-primary w-100 h-[48px]' />
                    {/* )} */}
                  </div>

                  <Skeleton className='f-10 mt-2' />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <Slider {...settings} adaptiveHeight={true} beforeChange={() => setShow(false)}>
          {products.map((product) => (
            <div className='product-item'
              key={product.Si}  >

              <div className='product-img aspect-[4/4]'>
                <img src={product.Pic_A ? product.Pic_A : ProductImage} className='img-box img-product' alt={product.KalaName} onClick={() => {
                  if (!isSliding) navigate(`/product?id=${product.Code}`);
                }}
                  onError={(e) => {
                    e.target.onerror = null; // جلوگیری از لوپ بی‌نهایت
                    e.target.src = ProductImage;
                  }} />
                <img src={product.isFavorit ? HeartBold : Hearth} className='favorite-icon' alt="" onClick={(e) => { e.stopPropagation(); changeFavorit(product) }} />
              </div>
              <div>
                <div className='detail' onClick={() => {
  if (!isSliding) navigate(`/product?id=${product.Code}`);
}}>
                  <h4 className='mt-4'>{convertToPersianNumbers(product.KalaName)}</h4>
                  <h5 className='mt-2 number-font'>{parseInt(product.Price).toLocaleString()} تومان</h5>
                </div>

                <div >
                  {/* {product.count >= product.MinOrder ? (
                    <>
                      <div className='d-flex align-items-center justify-content-center mt-4 gap-2 increas'>
                        <button className='btn btn-primary w-[48px]' onClick={(e) => { e.stopPropagation(); handleIncrease(product) }}>+</button>
                        <input
                          className='form-control w-[48px] h-[48px] text-center number-font'
                          style={{ height: '48px' }}
                          value={inputValues[product.Si] ? inputValues[product.Si] : product.count}
                          onChange={(e) => handleInputChange(product, e.target.value)}
                          onBlur={() => handleBlur(product)}
                        />
                        <button className='btn btn-primary w-[48px] d-flex align-items-center justify-center' onClick={(e) => { e.stopPropagation(); handleDecrease(product) }}>
                          {product.count === product.MinOrder ? <img src={Trash} /> : '-'}
                        </button>
                      </div>

                      {selectedDiscount?.id === product.Si && selectedDiscount?.discounts.length > 0 && (
                        <Overlay target={getRef(product.Si).current} show={show && selectedDiscount?.id === product.Si} placement="bottom">
                          {(props) => (
                            <Tooltip id="overlay-example" {...props}>
                              <div className="discount-list">
                                {selectedDiscount.discounts.map((discount, index) => (
                                  <div key={index} className="discount-item">
                                    <span className='number-font'>{discount.Nq ? discount.Nq : ''}</span>
                                    <span className='number-font'>{discount.Price ? discount.Price.toLocaleString() : ''} تومان</span>
                                  </div>
                                ))}
                              </div>
                            </Tooltip>
                          )} 
                        </Overlay>
                      )}


                    </>
                  ) : ( */}
                  <button className='mt-4 btn btn-primary w-100' onMouseDown={handleMouseDownslid}
                    onMouseMove={handleMouseMoveslid}
                    onMouseUp={() => handleMouseUpslid(product)}>افزودن</button>
                  {/* )} */}
                </div>

                <span className='f-10'>حداقل تعداد خرید محصول {convertToPersianNumbers((product.MinOrder)?.toString())} عدد</span>
              </div>

            </div>
          ))}

        </Slider>
      )}
      {/* Dialog with Carousel for Product Details */}
      <Dialog
        draggable={false}
        dismissableMask
        visible={visible}
        style={{ width: '35vw' }}
        breakpoints={{ '1800px': '25vw', '1600px': '35vw','1300px': '50vw', '1100px': '50vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
        onHide={handleDialogClose}
        className="custom-dialog "
      >
        <div className='product-item'>
          <div className='d-flex justify-content-start gap-4 mobile-direction'>
            <div className='product-img mx-0 aspect-[4/4]'>
              <img src={dialogContent.Pic_A} className='img-box img-product' alt={dialogContent.KalaName} />
              <img src={dialogContent.isFavorit ? HeartBold : Hearth} className='favorite-icon' alt="" onClick={(e) => { e.stopPropagation(); changeFavoritDialog(dialogContent) }} />
            </div>
            <div>
              <div className='detail text-center d-flex align-items-center gap-3 justify-content-between'>
                <div className='flex-1 text-right text-mobile-center'>
                  <h4 className='mt-4'>{convertToPersianNumbers(dialogContent.KalaName)}</h4>
                  <span className='text-sm'>توضیحات محصول: {dialogContent.Tp}</span>
                  <div className='d-flex align-items-center justify-content-start text-mobile-center gap-3 mt-2'>
                    <span className='text-[12px] item' >کد کالا: {convertToPersianNumbers(dialogContent.Code)}</span>
                    <span className='text-[12px] item' >گروه کالا: {dialogContent.GrpName}</span>
                  </div>
                  <div className='d-flex align-items-center gap-5 justify-content-start text-mobile-center'>
                    <h5 className={`${(dialogContent.discountPrice && dialogContent.discountPrice != dialogContent.Price) ? 'discount-price' : ''} mt-2 number-font`}>{parseInt(dialogContent.Price).toLocaleString()} تومان</h5>
                    {(dialogContent.discountPrice && dialogContent.discountPrice != dialogContent.Price) && (

                      <h5 className='mt-2 number-font'>{parseInt(dialogContent.discountPrice).toLocaleString()} تومان</h5>
                    )}
                  </div>

                  <span className='text-[12px] item'>حداقل تعداد خرید محصول {convertToPersianNumbers((dialogContent.MinOrder)?.toString())} عدد</span>
                </div>



              </div>
            </div>
          </div>
          {selectedDiscount?.id === dialogContent.Si && selectedDiscount?.discounts.length > 0 && (
            <div className="discount-list  flex-1 mt-4">
              {/* <h4 className='mt-4 text-lg text-right'>تخفیفات</h4> */}

              {selectedDiscount.discounts.map((discount, index) => (
                <div key={index} className="discount-item p-2">
                  <span className="number-font">{discount.Nq ?? ''}</span>
                  {discount.Price && (<span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>)
}
                </div>
              ))}
            </div>
          )}

          {dialogContent.count >= dialogContent.MinOrder ? (
            <div>
              <div className='text-center w-100 d-flex justify-content-end'>
                <div className='d-flex align-items-center justify-content-center mt-4 gap-2 increas w-fit' ref={getRef(dialogContent.Si)}>
                  <button className='btn btn-primary w-[48px]' onClick={handleDialogIncrease}>+</button>
                  {loadingQuantities ? (
                    <div className='form-control w-[48px] h-[48px] text-center three-loader d-flex align-items-center justify-content-center' style={{ width: '48px', height: '48px' }}>
                      <ThreeLoader />

                    </div>
                  ) : (
                    <input
                      className={`form-control w-[48px] h-[48px] text-center number-font ${loadingQuantities ? 'loading-dots' : ''}`}
                      style={{ height: '48px' }}
                      value={inputValues[dialogContent.Si] ?? dialogContent.count}
                      onChange={(e) => handleInputChange(dialogContent, e.target.value)}
                    // onMouseEnter={async () => {
                    //   setSelectedDiscount(null)
                    //   await fetchDiscountProduct(dialogContent.Si)
                    // }}
                    />
                  )}



                  <button className='btn btn-primary w-[48px] d-flex align-items-center justify-center' onClick={handleDialogDecrease}>
                    {dialogContent.count === dialogContent.MinOrder ? <img src={Trash} /> : '-'}
                  </button>
                </div>
              </div>

              {/* {selectedDiscount?.id === dialogContent.Si && selectedDiscount?.discounts.length > 0 && (
                <div ref={ref}>
                  <Overlay
                    target={getRef(dialogContent.Si).current}
                    show={show && selectedDiscount?.id === dialogContent.Si}
                    placement="left"
                  >
                    {(props) => (
                      <Tooltip id="overlay-example" {...props}>
                        <div className="discount-list">
                          {selectedDiscount.discounts.map((discount, index) => (
                            <div key={index} className="discount-item">
                              <span className="number-font">{discount.Nq ?? ''}</span>
                              <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                            </div>
                          ))}
                        </div>
                      </Tooltip>
                    )}
                  </Overlay>
                </div>

              )} */}
              <hr />
              <div className='d-flex align-items-center justify-content-between'>
                <div>
                  <h6 className='text-sm number-font d-flex' style={{ flexWrap: 'wrap' }}>مجموع ({inputValues[dialogContent.Si] ? inputValues[dialogContent.Si] : dialogContent.count} کالا) : <span className='text-[#00a14b] font-bold number-font'>{getTotalPrice(dialogContent.Price, dialogContent)} تومان</span></h6>
                </div>
                <button className='btn btn-outline-primary py-1 h-[40px]' style={{ fontSize: '12px', height: '40px', textWrap: 'nowrap' }} onClick={() => { window.location.href = '/orders' }}>مشاهده سبد خرید</button>
              </div>
            </div>

          ) : (
            <button className='mt-3 btn btn-primary w-100' onClick={(e) => handleAddToBasket(dialogContent, e)}>افزودن</button>
          )}
        </div>
      </Dialog>


    </>
  );
}
